import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer group">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-fill text-lg text-background-50 dark:text-foreground-950"></i>
              </div>
              <span className="text-xl font-heading font-bold text-foreground-50 group-hover:text-primary-400 transition-colors">
                星辰影院
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              星辰影院汇集免费电视剧全集，最新热播剧、国产剧高清在线观看，全程不缓冲流畅播放，追剧首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-100 mb-4">
              <a href="#category-section" className="hover:text-primary-400 transition-colors">剧集分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-100 mb-4">
              <a href="#quick-links" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/guochanju" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  热播推荐
                </Link>
              </li>
              <li>
                <Link to="/category/hanju" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  最新上线
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-100 mb-4">
              <a href="#contact-section" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-foreground-600 w-4 h-4 flex items-center justify-center"></i>
                <span>contact@xingchencinema.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-foreground-600 w-4 h-4 flex items-center justify-center"></i>
                <span>在线客服：7×24小时</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-foreground-600 w-4 h-4 flex items-center justify-center"></i>
                <span>中国·北京</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-300 cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-300 cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-300 cursor-pointer" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/60">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {currentYear} 星辰影院 XingChen Cinema. 保留所有权利。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}